























































































































































































import { Vue, Component } from 'vue-property-decorator';
import SetSecretQuestion from '@/views/basicFunctions/personalCenter/setSecretQuestion.vue';

@Component({
  components: {
    SetSecretQuestion,
  },
})
export default class PersonalCenter extends Vue {
  scrollbar = true;
  cancelFlag = false;
  showSetSecretQuestionFlag = false;
  setPhoneNumDialog = false;
  setPassWdDialog = false;
  sex: any = [
    {
      id: 0,
      value: '男',
      label: '男',
    },
    {
      id: 1,
      value: '女',
      label: '女',
    },
  ];
  setPhoneNumForm: any = {
    phoneNumber: '',
    verificationCode: '',
  };

  setPassWdForm: any = {
    oldPassWd: '',
    newPassWd: '',
    repeatNewPassWd: '',
  };

  basicInfo: object = {
    name: '',
    department: '',
    sex: '',
    quarters: '',
    mailbox: '',
    birthday: '',
    detailedAddress: '',
  };

  imageUrl: any = '';

  basicInfoRules: object = {
    name: [
      { required: true, message: '请输入姓名', trigger: 'blur' },
      { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' },
    ],
    department: [{ required: true, message: '请输入部门', trigger: 'blur' }],
    sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
    quarters: [{ required: true, message: '请输入岗位', trigger: 'blur' }],
    mailbox: [
      { required: true, message: '请输入邮箱地址', trigger: 'blur' },
      { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] },
    ],
    birthday: [{ validator: this.validateBirthday, trigger: 'blur' }],
    detailedAddress: [
      { required: true, message: '请输入详细地址', trigger: 'blur' },
      { max: 50, message: '长度最大为50个字符', trigger: 'change' },
    ],
  };

  private async validateBirthday(rule: any, value: any, callback: any) {
    const dateReg = /^(\d{4})-(0\d{1}|1[0-2])-(0\d{1}|[12]\d{1}|3[01])$/;
    if (!value) {
      callback(new Error('请输入生日'));
    } else if (!dateReg.test(value)) {
      callback(new Error("请输入'YYYY-MM-DD'的日期格式"));
    }
    callback();
  }

  mounted() {
    this.hasScrollbar();
  }

  hasScrollbar() {
    const dom: any = document.getElementById('main_box');
    this.scrollbar = dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight;
  }

  private handleAvatarSuccess(res: any, file: any): void {
    console.log('file', file);
    this.imageUrl = URL.createObjectURL(file.raw);
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击编辑按钮时候的事件
   * @param1 暂无
   * @returns 暂无
   */
  private showCancelBtn(): void {
    this.cancelFlag = true;
  }

  private hideCancelBtn(type: string, value: any): void {
    this.cancelFlag = false;
    if (type === 'save') {
      const basicInfo: any = 'basicInfo';
      const ccc: any = this.$refs[basicInfo];
      ccc.validate((valid: any) => {
        if (valid) {
          this.$message.success('保存成功!!!');
        } else {
          this.cancelFlag = true;
          console.log('error submit!!!');
          return false;
        }
      });
    } else {
      console.log(this.cancelFlag, 123); // 点击取消的时候
    }
  }

  private closeSetSecretQuestion(): void {
    this.showSetSecretQuestionFlag = false;
  }

  private openPhoneNumDialog(): void {
    this.setPhoneNumDialog = true;
  }

  private sendVerCode(): void {
    console.log('发送验证码ing');
  }

  private closePhoneNumDialog(setPhoneNumForm: any): void {
    this.setPhoneNumDialog = false;
    this.$nextTick(() => {
      (this.$refs[setPhoneNumForm] as any).resetFields();
    });
  }

  private submitPhoneNumDialog(formName: any): void {
    // this.$refs['form'].validate(valid => {
    //     if(valid) { // 请求后台接口  表示验证通过
    //         // 请求后台接口  进行操作
    //         // 请求成功之后 清除输入框汇中的内容
    //         this.$nextTick(() => {
    //             // form对应你写的<el-form ref="form"></el-form>
    //             (this.$refs["form"]as any).resetFields();
    //         });
    //     }
    // });

    const setPhoneNumForm: any = 'setPhoneNumForm';
    const aaa: any = this.$refs[setPhoneNumForm];
    aaa.validate((valid: any) => {
      if (valid) {
        const boundPhone: any = document.querySelector('#bound-phone');
        boundPhone.innerHTML = '已绑定：' + this.setPhoneNumForm.phoneNumber;
        (aaa as any).resetFields();
        this.setPhoneNumDialog = false;
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }

  phoneNumRules: object = {
    phoneNumber: [
      { required: true, message: '请输入手机号码', trigger: 'blur' },
      { pattern: /^1[34578]\d{9}$/, message: '手机号码格式不正确' },
    ],
    verificationCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
  };

  private openPassWdDialog(): void {
    this.setPassWdDialog = true;
  }

  private closePassWdDialog(setPassWdForm: any): void {
    this.setPassWdDialog = false;
    this.$nextTick(() => {
      (this.$refs[setPassWdForm] as any).resetFields();
    });
  }

  private submitPassWdDialog(formName: any): void {
    // this.$refs['form'].validate(valid => {
    //     if(valid) { // 请求后台接口  表示验证通过
    //         // 请求后台接口  进行操作
    //         // 请求成功之后 清除输入框汇中的内容
    //         this.$nextTick(() => {
    //             // form对应你写的<el-form ref="form"></el-form>
    //             (this.$refs["form"]as any).resetFields();
    //         });
    //     }
    // });

    const setPassWdForm: any = 'setPassWdForm';
    const bbb: any = this.$refs[setPassWdForm];
    bbb.validate((valid: any) => {
      if (valid) {
        this.setPassWdDialog = false;
        this.$message.success('密码修改成功!!!');
        this.$nextTick(() => {
          (this.$refs[setPassWdForm] as any).resetFields();
        });
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }

  private async validatePass(rule: any, value: any, callback: any) {
    if (!value) {
      callback(new Error('请输入新密码'));
    } else if (value.toString().length < 6 || value.toString().length > 18) {
      callback(new Error('密码长度为6 - 18个字符'));
    } else if (value === this.setPassWdForm.oldPassWd) {
      callback(new Error('更改的密码不能和原密码一样'));
    } else {
      callback();
    }
  }

  private async validatePass2(rule: any, value: any, callback: any) {
    if (value === '') {
      callback(new Error('请再次输入密码'));
    } else if (value !== this.setPassWdForm.newPassWd) {
      callback(new Error('两次输入密码不一致!'));
    } else {
      callback();
    }
  }

  passWdRules: object = {
    oldPassWd: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
    newPassWd: [{ required: true, validator: this.validatePass, trigger: 'blur' }],
    repeatNewPassWd: [{ required: true, validator: this.validatePass2, trigger: 'blur' }],
  };

  showSetSecretQuestion() {
    this.showSetSecretQuestionFlag = true;
  }

  private back() {
    this.$emit('back');
  }
}
